import Page from './page';
import QuickAddToCart from '../components/cart/quick-add-to-cart';
import OrderTemplateModals from '../components/orders/order-template-modals';
import CartQuantitySelector from '../components/cart/cart-quantity-selector';
import FormSubmitHelper from '../helpers/form-submit-helper';
import DeliveryAvailability from '../components/product/delivery-availability';

export default class CartPage extends Page {
  private readonly cartSidebarForm: JQuery<HTMLFormElement>;
  private readonly cartSubmitForm: JQuery<HTMLFormElement>;
  private readonly quickAddToCart: QuickAddToCart;

  private readonly createFromCartBtn: JQuery;
  private readonly refrigerantForms: JQuery<HTMLFormElement>;
  private readonly refrigerantInputs: JQuery;
  private readonly fibForms: JQuery<HTMLFormElement>;
  private readonly fibInputs: JQuery;

  private readonly orderTemplateModals: OrderTemplateModals;

  constructor(body: JQuery) {
    super();

    this.cartSidebarForm = body.find<HTMLFormElement>('.js-cartSidebarForm');
    this.cartSubmitForm = body.find<HTMLFormElement>('.js-cartSubmitForm');
    this.quickAddToCart = new QuickAddToCart(body.find('.js-quick-add-form'));
    this.createFromCartBtn = body.find('.js-createFromCartOrderTemplateModalButton');
    this.refrigerantForms = body.find<HTMLFormElement>('.js-refrigerantForm');
    this.refrigerantInputs = body.find('.js-refrigerantInput');
    this.fibForms = body.find<HTMLFormElement>('.js-fibForm');
    this.fibInputs = body.find('.js-fibInput');
    this.orderTemplateModals = new OrderTemplateModals($('body'));
    this.orderTemplateModals.bindOpenCreateFromCartModal();

    CartQuantitySelector.initAll();
    DeliveryAvailability.initAll();

    this.bindAutoSaveForms();
    this.bindValidateSidebarFormOnCartSubmit();
    this.bindDeliveryDateTooltip();
  }

  private bindAutoSaveForms(): void {
    const blurHandler = (e: Event) => {
      const form = $<HTMLFormElement>((e.target as HTMLInputElement).form as HTMLFormElement);
      CartPage.submitIfValid(form);
    };

    this.fibInputs.on('blur', blurHandler);
    this.refrigerantInputs.on('blur', blurHandler);

    const submitHandler = (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      CartPage.submitIfValid($<HTMLFormElement>((e.target as HTMLButtonElement).form as HTMLFormElement));
    };

    this.refrigerantForms.find('button').on('click', submitHandler);
    this.fibForms.find('button').on('click', submitHandler);
  }

  private bindValidateSidebarFormOnCartSubmit(): void {
    this.cartSubmitForm.on('submit', (e) => {
      const isValid = this.cartSidebarForm.parsley().validate();
      if (!isValid) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      } else {
        FormSubmitHelper.showLoader(this.cartSubmitForm);
      }
    });
  }

  private bindDeliveryDateTooltip(): void {
    $('.js-deliveryDates').map((_, element) => {
      const container = element;
      return new DeliveryAvailability(container);
    });
  }

  private static submitIfValid(form: JQuery<HTMLFormElement>): void {
    let allInputsValid = true;
    if (form[0].id) {
      const inputsOutsideForm = $(`[form="${form[0].id}"]:not([disabled])`);
      inputsOutsideForm.each((_, element) => {
        const input = $(element);
        input.parsley().validate();
        if (!input.parsley().isValid()) {
          allInputsValid = false;
        }
      });
    }

    form.parsley().validate();
    if (form.parsley().isValid() && allInputsValid) {
      form.submit();
    }
  }
}
